import React from "react";
import { FRONTEND_ENDPOINTS } from "Theconstants";
import { useAppSelector, userSelector } from "context/store";
import { Navigate, Outlet, useLocation } from "react-router-dom";

export const CheckUser = ({ admin }: { admin: IUser["admin"] }) => {
  /*   console.log("check user, POS check storage"); */
  const location = useLocation();
  /*   console.log(location, "LOCATION VER Q SALE"); */
  const { user } = useAppSelector(userSelector);

  return !user ? (
    <Navigate
      to={`${FRONTEND_ENDPOINTS.LOGIN}#`}
      state={{ from: location }}
      replace
    />
  ) : user.admin === admin || user.admin ? (
    <Outlet />
  ) : (
    <Navigate to={`${FRONTEND_ENDPOINTS.USER_PROFILE}#`} />
  );
};
